import { CashConfigTab } from './CashConfig.jsx';
import { Header, useOpsContext } from './ui.jsx';

const billingUrl = import.meta.env.VITE_BILLING_URL || 'http://localhost:5714';

/**
 * Sổ ca tiền mặt và tính tiền đã chuyển sang One Play Billing.
 * Manager chỉ giữ bảng giá và cấu hình ca làm dữ liệu gốc: HQ đặt mặc định, từng chủ nhượng quyền chỉnh riêng.
 */
export function CashShiftsPage() {
  const { auth, fail, success } = useOpsContext();
  return <main className="content-page">
    <Header eyebrow="BẢNG GIÁ" title="Bảng giá & cấu hình ca" description="Dữ liệu gốc mà One Play Billing dùng để tính tiền giờ chơi và mở ca. Thu tiền, sổ ca và hóa đơn thực hiện ở Billing.">
      <a className="btn subtle" href={billingUrl} target="_blank" rel="noreferrer">Mở One Play Billing</a>
    </Header>
    <CashConfigTab auth={auth} fail={fail} success={success} />
  </main>;
}
